import { createSlice } from "@reduxjs/toolkit";

const encounterSlice = createSlice({
    name: "encounters",
    initialState: {},
    reducers: {
        registerEncounter: (state, action) => {
            const encounter = action.payload;
            if (encounter?.id) {
                state[encounter.id] = encounter;
            }
        },
        bulkRegisterEncounters: (state, action) => {
            action.payload.forEach((encounter) => {
                if (encounter?.id) {
                    state[encounter.id] = encounter;
                }
            });
        }
    }
});

export const { registerEncounter, bulkRegisterEncounters } = encounterSlice.actions;
export default encounterSlice.reducer;